import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=cb9355ca&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=ts&"
export * from "./Player.vue?vue&type=script&lang=ts&"
import style0 from "./Player.vue?vue&type=style&index=0&id=cb9355ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9355ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/p00353_hh-ballett/client-player/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb9355ca')) {
      api.createRecord('cb9355ca', component.options)
    } else {
      api.reload('cb9355ca', component.options)
    }
    module.hot.accept("./Player.vue?vue&type=template&id=cb9355ca&scoped=true&", function () {
      api.rerender('cb9355ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Player.vue"
export default component.exports